import {createApp} from 'vue';
import StudentEnrolmentTable from './StudentEnrolmentTable.vue';
import {createBootstrap} from 'bootstrap-vue-next';
import VueMultiselect from 'vue-multiselect';

window.addEventListener('load', () => {
  const container = $('#student-enrolment-container');
  if (container.length) {
    createApp(StudentEnrolmentTable, container.data())
       .use(createBootstrap())
        .component('VMultiselect', VueMultiselect)
        .mount(container[0]);
  }
});
